import * as zod from 'zod';

export const S3BucketCommand = zod.object({
  kind: zod.literal('S3BucketCommand'),
  command: zod.discriminatedUnion('command', [
    zod.object({
      command: zod.literal('uploadFile'),
      localPath: zod.string(),
      remotePath: zod.string(),
    }),
    zod.object({
      command: zod.literal('testConnection'),
    }),
  ]),
});

export type S3BucketCommand = zod.infer<typeof S3BucketCommand>;
